import type { Container, Text } from 'pixi.js';
import { onLayoutPopulated } from '../populate';

export function layoutUpperCaseSPL(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: { root: Container; upperCase_SPL?: Text[] | Text }) => {
    if (!layout.upperCase_SPL) return;

    const texts = Array.isArray(layout.upperCase_SPL) ? layout.upperCase_SPL : [layout.upperCase_SPL];

    texts.forEach((text) => {
      text.text = text.text.toUpperCase();
    });
  });
}
